// extracted by mini-css-extract-plugin
export default {"AddHealthChecksTagsDialog":"AddHealthChecksTagsDialog_AddHealthChecksTagsDialog__VHFtW"};